import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SessionInactivityService } from '../../../../core/auth/session-inactivity.service';

@Component({
    selector: 'app-inactivity-warning-snackbar',
    imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule],
    templateUrl: './inactivity-warning-snackbar.component.html',
    styleUrls: ['./inactivity-warning-snackbar.component.scss']
})
export class InactivityWarningSnackbarComponent {
    private readonly service = inject(SessionInactivityService);
    private readonly snackBarRef = inject(MatSnackBarRef<InactivityWarningSnackbarComponent>);
    private readonly data = inject(MAT_SNACK_BAR_DATA);

    readonly countdownDisplay = computed(() => this.service.countdownDisplay());

    onStayLoggedIn(): void {
        // Call keep-alive to extend session and reset timer
        this.service.resetActivity();
        // Dismiss snackbar
        this.snackBarRef.dismiss();
    }
}
